// Normalize HeadersInit before object-spreading in the legacy interceptor chain.
// set (not append) replaces every case variant, including combined duplicates.
export function jsonHeaders(value) {
  const headers = new Headers(value);
  headers.set('content-type', 'application/json');
  return Object.fromEntries(headers.entries());
}
